import {
  NotificationItem,
  NotificationMetadataStatus,
  NotificationType,
} from '@aibees/shared/features/notifications';
import { NotificationDetailProps } from '@aibees/shared/features/notifications/components/notification-detail';
import { notificationBadgeInfoMap } from '@aibees/shared/features/notifications/config';
import { NotificationActionPopup } from '../components';
import {
  notificationBodyMap,
  notificationIconMap,
  notificationMetadataMap,
  notificationTitleMap,
} from '../utils';

export const getNotificationConfig = (
  item: NotificationItem
): NotificationDetailProps => ({
  // TODO remove NotificationType.Export and NotificationMetadataStatus.SUCCESS after getting type from server
  body: notificationBodyMap[item.message?.metadata.type]?.[
    item.message?.metadata.status
  ],
  badgeInfo:
    notificationBadgeInfoMap[
      item.message?.metadata.status ?? NotificationMetadataStatus.SUCCESS
    ],
  title:
    notificationTitleMap[
      item.message?.metadata.type ?? NotificationType.EXPORT
    ]?.[item.message?.metadata.status ?? NotificationMetadataStatus.SUCCESS] ??
    '',
  icon: notificationIconMap[
    item.message?.metadata.type ?? NotificationType.EXPORT
  ],
  actions: <NotificationActionPopup item={item} />,
  metadata:
    notificationMetadataMap[
      item.message?.metadata.type ?? NotificationType.EXPORT
    ]?.(item),
  divider: true,
  item,
});
